module.exports = __webpack_public_path__ + "static/st-2-365442656e5c6ed1b0000d8aa1cceae4.jpg";